var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerbar"},[_c('p',[_vm._v("Copyright © 2017–2021 Larissa Thayer Cullen, all rights reserved")])])}]

export { render, staticRenderFns }